import React from 'react';
import './sec5.css'
import Featuredexh from '../components/common/featuredexh';
import { useEffect } from 'react';
import gsap from 'gsap';
import { supabase } from '../supabase';
import { useState } from 'react';

const Sec5 = () => {

  const [Exhibitors, setExhibitors]= useState([]);
const [headers, setheaders]= useState([]);
 useEffect(() => {
    const rows = document.querySelectorAll('.row-sec5');

    rows.forEach((el) => {
      const image = el.querySelector('.hover-img-sec5');
      const setX = gsap.quickTo(image, 'x', { duration: 0.4, ease: 'power3' });
      const setY = gsap.quickTo(image, 'y', { duration: 0.4, ease: 'power3' });

      let firstEnter;
         const align = (e) => {
        if (firstEnter) {
          setX(e.clientX, e.clientX);
          setY(e.clientY, e.clientY);
          firstEnter = false;
        } else {
          setX(e.clientX);
          setY(e.clientY);
        }};

      const startFollow = () => document.addEventListener('mousemove', align);
      const stopFollow = () => document.removeEventListener('mousemove', align);
      const fade = gsap.to(image, {
        autoAlpha: 1,
        ease: 'none',
        paused: true,
        duration: 0.1,
        onReverseComplete: stopFollow
      });

      el.addEventListener('mouseenter', (e) => {
        firstEnter = true;
        fade.play();
        startFollow();
        align(e);
      });

      el.addEventListener('mouseleave', () => fade.reverse());
    });


  }, [Exhibitors]);




useEffect(() => {
const getExhibitors = async()=>{
const res = await supabase
  .from('exhibitors')
  .select(`
    *,
    exhibitor_categories (
      category (
        category_name
      )
    )
  `)
 .eq('is_featured', true)  
      .order('id', { ascending: true });

    setExhibitors(res.data || []);
  };
  getExhibitors();
}, []);


useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setheaders(res.data);
}
getheaders();
}, []);






    return ( 
        <section className='sec5'>
                <section className='container-sec5'>
                    <h1 className='header-sec5'>{headers?.[3]?.header}</h1>
                    <article className='main-cont-sec5'>


                     {Exhibitors.map((item, index) => (
                      <React.Fragment key={item.id || index}>
                        
                      <Featuredexh
                        title={item.exhibitor_name}
                        booth={`Booth ${item.booth_number}`}
                        category={
                          item.exhibitor_categories
                            ?.map(c => c?.category?.category_name)
                            ?.join(', ')
                        }
                        img={item.image}
                        alt1={item.img_alt}
                        img2={item.hover_image}
                        alt2={item.hover_alt}
                      />
                   
                          <div className='rect-sec5'></div>
              

                      </React.Fragment>
                    ))}



                    </article>
                </section>
        </section>
     );
}
 
export default Sec5;